import React from 'react'

import {
  LinkAccountConfirmationPage,
  SignInToLinkAccountPage,
} from 'cloud-frontend'
import {
  IndexLayoutExtraProps,
  useUserAuthorizations,
} from '@sketch/modules-common'

interface SsoLinkAccountRouteProps extends IndexLayoutExtraProps {}

export const SsoLinkAccountRoute = (props: SsoLinkAccountRouteProps) => {
  const { hasPersonalAuthorization } = useUserAuthorizations()

  if (hasPersonalAuthorization) {
    return <LinkAccountConfirmationPage {...props} />
  } else {
    return <SignInToLinkAccountPage {...props} />
  }
}
